/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingPricingPlan } from './BillingPricingPlan';
// @ts-ignore
import {
// @ts-ignore
    BillingPricingPlanFromJSON,
// @ts-ignore
    BillingPricingPlanFromJSONTyped,
// @ts-ignore
    BillingPricingPlanToJSON,
} from './BillingPricingPlan';

/**
 * 
 * @export
 * @interface BillingPricing
 */
export interface BillingPricing {
    /**
     * 
     * @type {string}
     * @memberof BillingPricing
     */
    ownerType: BillingPricingOwnerTypeEnum;
    /**
     * 
     * @type {Array<BillingPricingPlan>}
     * @memberof BillingPricing
     */
    plans: Array<BillingPricingPlan>;
}


/**
 * @export
 */
export const BillingPricingOwnerTypeEnum = {
    Store: 'store',
    Supplier: 'supplier',
    Retailer: 'retailer'
} as const;
export type BillingPricingOwnerTypeEnum = typeof BillingPricingOwnerTypeEnum[keyof typeof BillingPricingOwnerTypeEnum];


/**
 * Check if a given object implements the BillingPricing interface.
 */
// @ts-ignore
export function instanceOfBillingPricing(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ownerType" in value;
    isInstance = isInstance && "plans" in value;

    return isInstance;
}

// @ts-ignore
export function BillingPricingFromJSON(json: any): BillingPricing {
    return BillingPricingFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingPricingFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPricing {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ownerType': json['owner_type'],
        'plans': ((json['plans'] as Array<any>).map(BillingPricingPlanFromJSON)),
    };
}

// @ts-ignore
export function BillingPricingToJSON(value?: BillingPricing | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'owner_type': value.ownerType,
        'plans': ((value.plans as Array<any>).map(BillingPricingPlanToJSON)),
    };
}

